/**
 * SVG Icon
 */

import anime from 'animejs';

const imageTrack = {
    cfg: {
        name: 'imageTrack',
        controller: '',
        trigger: document.querySelectorAll('.js-imageTrack'),
        path: anime.path('.js-imageTrack #track-motion'),
    },

    init() {
        window.addEventListener('load', () => {
            // Script
            /* var path = anime.path('.motion-path-demo #track-motion'); */

            anime({
                targets: '#track-car',
                translateX: this.cfg.path('x'),
                translateY: this.cfg.path('y'),
                rotate: this.cfg.path('angle'),
                easing: 'linear',
                duration: 16000,
                loop: true
            });
        });
    }
};

export default imageTrack;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/imageTrack/_script.js